import './index.scss'

if (document.querySelectorAll('.calendly-inline-widget').length > 0) {
  document.addEventListener('DOMContentLoaded', () => {
    addScript('https://assets.calendly.com/assets/external/widget.js')
  })
}

function addScript(url, callback) {
  const script = document.createElement('script')
  if (callback) {
    script.onload = callback
  }
  script.type = 'text/javascript'
  script.src = url
  document.body.appendChild(script)
}
